/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RowItem.vue?vue&type=template&id=0c9e261f&scoped=true"
var script = {}
import style0 from "./RowItem.vue?vue&type=style&index=0&id=0c9e261f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e261f",
  null
  
)

export default component.exports